<script setup lang="ts">
import { Planungsgeschaeft } from '@/models/Planungsgeschaeft';
import { inject, type Ref } from 'vue';
import PrevNextBtnBar from '@/components/PrevNextBtnBar.vue';

// injected from PlanungsgeschaeftEditView
const saving = inject('saving') as Ref<boolean>;
const readonly = inject('readonly') as Ref<boolean>;

const props = defineProps<{
    geschaeft: Planungsgeschaeft;
}>();

const emit = defineEmits<{
    'geschaeft-changed': [section: string | null];
    next: [];
    prev: [];
}>();

function onReset() {
    emit('prev');
}

async function onNextStep() {
    emit('next');
}

/**
 * When this route is about to leave, we inform the parent so that it
 * has a chance to save the Geschaeft first.
 */
// onBeforeRouteLeave((to, from) => {
//     onGeschaeftChanged();
//     return true;
// });

/**
 * Called when this component did changes on the Geschaeft model instance.
 * It is in the parent's responsibility to save the model.
 */
// function onGeschaeftChanged() {
//     emit('geschaeft-changed', 'abschluss');
// }
function mutateGeschaeft(field: string, value: any) {
    props.geschaeft.set(field, value);
}
</script>

<template>
    <div>
        <h4 class="ktg-title-04 ktg-inner-box-padding mb-1_5rem">{{ $t('anmerkungen') }}</h4>
        <fieldset class="ktg-fieldset ktg-form-area-maxwidth py-3_5rem px-6rem">
            <h5 class="ktg-title-05 mb_1rem ktg-inner-box-padding">{{ $t('remark_anmerkungen') }}</h5>
            <ktg-line class="mt-0_5rem mb-1rem"></ktg-line>

            <ktg-field>
                <ktg-label for="remark">{{ $t('your_msg') }}</ktg-label>
                <ktg-text-area
                    class="w-full"
                    input-id="remark"
                    :value="geschaeft.remark"
                    :readonly="readonly"
                    name="remark"
                    maxlength="1000"
                    rows="10"
                    @change="mutateGeschaeft('remark', $event.target.value)"
                >
                </ktg-text-area>
            </ktg-field>

            <ktg-line class="mt-2rem mb-1rem"></ktg-line>
            <PrevNextBtnBar
                :back-text="$t('back')"
                :next-text="$t('to_next_step')"
                :disabled="saving"
                @next="onNextStep"
                @back="onReset"
            />
        </fieldset>
    </div>
</template>
